import { InjectionToken } from '@angular/core';
import copyToClipboard from 'copy-text-to-clipboard';

export const CopyToClipboardToken = new InjectionToken('CopyToClipboard');
export function copyToClipboardProvider() {
    return copyToClipboard;
}
